module.exports = __webpack_public_path__ + "img/a-03.ce8211ef.png";